/** @jsxImportSource @emotion/react */
import showPasswordImg from '../../assets/icons/showPassword.svg';
import hidePasswordImg from '../../assets/icons/hidePassword.svg';

import * as React from 'react';
import { css, SerializedStyles } from '@emotion/react';
import { InputColors, InputEffects, InputShape, InputSize } from './Input';
import { Row } from '../../layout/flexbox';
import { onIe } from '../../language/browser';
import { assoc } from '../../language/module';
import { getResource } from '../../language/resources/getResource';

/**
 * A fake password to use in the password field when the password is masked and read-only so others can't see how long a
 * password is.
 */
const DUMMY_PASSWORD = '...............';

const passwordImage = css`
  cursor: pointer;
  padding-left: 14px; /* Same padding as on your standard input */
  padding-right: 14px; /* Same padding as on your standard input */

  ${
  onIe()
  ? css`
    width: 38px;
    height: 38px;
    flex-basis: 38px;
  `
  : ''
};
`;

/**
 * PasswordField: a component that renders a field for entering passwords
 *
 * PureComponent: true
 * Connected to Redux: false
 */
export default class PasswordField extends React.PureComponent<{
  editable: boolean;
  hasError: boolean;
  password: string | undefined;
  placeholder: string;
  onPasswordChange: (newValue: string) => void;
  rootCss?: SerializedStyles;
  required?: boolean;
  minLength?: number;
  maxLength?: number;
  pattern?: string;
  autofill?: boolean;
  hidePasswordVisibility?: boolean;
  resources: Record<string, any>;
}, {
  showPassword: boolean
}> {
  public static defaultProps = {
    editable:    true,
    hasError:    false,
    placeholder: '',
    autofill:    true,
  };

  public state = {
    showPassword: false,
  };


  public onPasswordChange = event => this.props.onPasswordChange(event.target.value);


  public toggleShowPassword = () => this.setState(prev => assoc('showPassword', !this.state.showPassword, prev));


  public render = () => {

    return (
    <Row rootCss={css`
           ${this.props.editable ? InputColors : ''};
           ${this.props.editable ? InputShape : ''};
           ${this.props.rootCss};
         `}>
      <input readOnly={!this.props.editable}
             value={!this.props.editable && !this.state.showPassword ? DUMMY_PASSWORD : this.props.password}
             type={this.state.showPassword ? 'text' : 'password'}
             onChange={this.onPasswordChange}
             placeholder={this.props.placeholder}
             autoComplete={this.props.autofill ? 'on' : 'new-password'}
             required={this.props.required}
             minLength={this.props.minLength}
             maxLength={this.props.maxLength}
             pattern={this.props.pattern}
             css={css`
               border: none;
               background-color: transparent;
               ${InputEffects};
               ${InputSize};
               padding-right: 0;
             `}/>
      {
        !this.props.hidePasswordVisibility
        && <img src={this.state.showPassword ? hidePasswordImg : showPasswordImg}
                alt={this.state.showPassword ? '◎' : '◉'}
                title={this.state.showPassword ? getResource(this.props.resources, 'PASSWORD_FIELD_HIDE_PASSWORD') : getResource(this.props.resources, 'PASSWORD_FIELD_SHOW_PASSWORD')}
                onClick={this.toggleShowPassword}
                tabIndex={0}
                css={passwordImage}/>
      }
    </Row>
    );
  };
}
